import flagUk from 'static/flags/gbr.svg';
import flagDK from 'static/flags/dnk.svg';
import flagDE from 'static/flags/deu.svg';
import flagPL from 'static/flags/pol.svg';
import { TFunction } from 'react-i18next';

export interface Country {
  name: string;
  alpha2Code: string;
  flag: string;
}

export const getCountries = (t: TFunction<string[]>): Country[] => {
  return [
    {
      name: t('countries.uk'),
      alpha2Code: 'UK',
      flag: flagUk,
    },
    {
      name: t('countries.dk'),
      alpha2Code: 'DK',
      flag: flagDK,
    },
    {
      name: t('countries.de'),
      alpha2Code: 'DE',
      flag: flagDE,
    },
    {
      name: t('countries.pl'),
      alpha2Code: 'PL',
      flag: flagPL,
    },
  ];
};
